export default __webpack_public_path__ + "static/media/Sintony.b7d03825.woff2";